/**
 * 通用js方法封装处理
 * Copyright (c) 2019 ruoyi
 */
import config from "./config"

const baseURL = config.apiUrl

// 日期格式化
export function parseTime(time, pattern) {
    if (arguments.length === 0 || !time) {
        return null
    }
    const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
        date = time
    } else {
        if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
            time = parseInt(time)
        } else if (typeof time === 'string') {
            time = time.replace(new RegExp(/-/gm), '/');
        }
        if ((typeof time === 'number') && (time.toString().length === 10)) {
            time = time * 1000
        }
        date = new Date(time)
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    }
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
        if (result.length > 0 && value < 10) {
            value = '0' + value
        }
        return value || 0
    })
    return time_str
}

// 表单重置
export function resetForm(refName) {
    if (this.$refs[refName]) {
        this.$refs[refName].resetFields();
    }
}

// 添加日期范围
export function addDateRange(params, dateRange) {
    var search = params;
    search.beginTime = "";
    search.endTime = "";
    if (null != dateRange && '' != dateRange) {
        search.beginTime = dateRange[0];
        search.endTime = dateRange[1];
    }
    return search;
}

// 回显数据字典
export function selectDictLabel(datas, value) {
    var actions = [];
    Object.keys(datas).some((key) => {
        if (datas[key].dictValue == ('' + value)) {
            actions.push(datas[key].dictLabel);
            return true;
        }
    })
    return actions.join('');
}

// 回显数据字典（字符串数组）
export function selectDictLabels(datas, value, separator) {
    if (value) {
        var actions = [];
        var currentSeparator = undefined === separator ? "," : separator;
        var temp = value.split(currentSeparator);
        Object.keys(value.split(currentSeparator)).some((val) => {
            Object.keys(datas).some((key) => {
                if (datas[key].dictValue == ('' + temp[val])) {
                    actions.push(datas[key].dictLabel + currentSeparator);
                }
            })
        })
        return actions.join('').substring(0, actions.join('').length - 1);
    } else {
        return ''
    }

}

// 通用下载方法
export function download(fileName) {
    window.location.href = baseURL + "/common/download?fileName=" + encodeURI(fileName) + "&delete=" + true;
}

// 字符串格式化(%s )
export function sprintf(str) {
    var args = arguments,
        flag = true,
        i = 1;
    str = str.replace(/%s/g, function () {
        var arg = args[i++];
        if (typeof arg === 'undefined') {
            flag = false;
            return '';
        }
        return arg;
    });
    return flag ? str : '';
}

// 转换字符串，undefined,null等转化为""
export function praseStrEmpty(str) {
    if (!str || str == "undefined" || str == "null") {
        return "";
    }
    return str;
}

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 * @param {*} rootId 根Id 默认 0
 */
export function handleTree(data, id, parentId, children, rootId) {
    id = id || 'id'
    parentId = parentId || 'parentId'
    children = children || 'children'
    rootId = rootId || Math.min.apply(Math, data.map(item => { return item[parentId] })) || 0
    //对源数据深度克隆
    const cloneData = JSON.parse(JSON.stringify(data))
    //循环所有项
    const treeData = cloneData.filter(father => {
        let branchArr = cloneData.filter(child => {
            //返回每一项的子级数组
            return father[id] === child[parentId]
        });
        branchArr.length > 0 ? father.children = branchArr : '';
        //返回第一层
        return father[parentId] === rootId;
    });
    return treeData != '' ? treeData : data;
}

// 输入最多2位小数的正数
// export function onInput(num, limit) {
//     var str = num.toString();
//     var len1 = str.substr(0, 1)
//     var len2 = str.substr(1, 1)
//         //如果第一位是0，第二位不是点，就用数字把点替换掉
//     if (str.length > 1 && len1 == 0 && len2 != ".") {
//         str = str.substr(1, 1)
//     }
//     //第一位不能是.
//     if (len1 == ".") {
//         str = ""
//     }
//     //限制只能输入一个小数点
//     if (str.indexOf(".") != -1) {
//         var str_ = str.substr(str.indexOf(".") + 1)
//         if (str_.indexOf(".") != -1) {
//             str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1)
//         }
//     }
//     //正则替换
//     str = str.replace(/[^\d^\.]+/g, '') // 保留数字和小数点
//     if (limit / 1 === 1) {
//         str = str.replace(/^\D*([0-9]\d*\.?\d{0,1})?.*$/, '$1') // 小数点后只能输 1 位
//     } else {
//         str = str.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1') // 小数点后只能输 2 位
//     }
//     return Number(str)
// }

export function onInput(num, isMinus = false) {
    let str = num.toString();
    //修复第一个字符是小数点 的情况.
    if (str != "" && (str.substr(0, 1) == "." || (!isMinus && str.substr(0, 1) == "-"))) {
        str = "";
    }
    str = str.replace(/^0*(0\.|[1-9])/, "$1"); //解决 粘贴不生效
    str = str.replace(/[^-\d.]/g, ""); //清除“数字”和“.”以外的字符
    str = str.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
    str = str
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
    str = str.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
    if (str.indexOf(".") < 0 && str != "") {
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        if (str.substr(0, 1) == "0" && str.length == 2) {
            str = str.substr(1, str.length);
        }
    }
    return str
}
export function isEmpty(val) {
    let boo = val === null || typeof val === 'undefined' || (typeof val === 'string' && val === '' && val !== 'undefined')
    return boo
}